exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.removed-movers-trucks[data-v-20e7a8c3] {\n  color: red;\n  text-decoration: line-through;\n}\n.log-box .mod-icon-minus[data-v-20e7a8c3] {\n  display: none;\n}\n.log-box .mod-icon-plus[data-v-20e7a8c3] {\n  display: block;\n}\n.log-box[aria-expanded='true'] .mod-icon-minus[data-v-20e7a8c3] {\n  display: block;\n}\n.log-box[aria-expanded='true'] .mod-icon-plus[data-v-20e7a8c3] {\n  display: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20e7a8c3","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/jobs/JobLogs.vue
// module id = LB9y
// module chunks = 0